import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { StoreModule } from '@ngrx/store'
import * as fromBasePaddleNumbers from './+state/base-paddle-numbers.reducer'
import { BasePaddleNumbersFacade } from './+state/base-paddle-numbers.facade'
import { EffectsModule } from '@ngrx/effects'
import { BasePaddleNumbersEffects } from './+state/base-paddle-numbers.effects'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromBasePaddleNumbers.PADDLE_NUMBERS_FEATURE_KEY, fromBasePaddleNumbers.reducer),
    EffectsModule.forFeature([BasePaddleNumbersEffects]),
  ],
  providers: [BasePaddleNumbersFacade],
})
export class SharedPaddleNumbersDataAccessModule {}
